@if (material) {
<div class="publication">
    <div class="images">
        <div class="image">
            <img [src]="material.url" />

            <div class="cart-extract">
                @if (material.bookExtractUrl) {
                <div class="extract" (click)="openPdf(material.bookExtractUrl)">
                    <a target="_blank">
                        <img src="./assets/images/materials/book_extract/beolvasas_icon.jpg" />
                    </a>
                    <span>Beleolvasó</span>
                </div>
                }
                <div class="desktop-button">
                    @if (material.isAvailable && material.routerLink !== 'morte_taska') {
                    <div class="shopping-cart-container">
                        @if (!material.hasPreorder) {
                        <div class="shopping-cart">
                            @if (material.quantityOfSupply !== 0) {
                            <button (click)="addToCart(material)">KOSÁRBA</button>
                            } @else {
                            <div class="inactive">
                                <button class="inactive-button" [ngStyle]="{ opacity: '0.5', cursor: 'auto' }">
                                    Elfogyott
                                </button>
                            </div>
                            }
                        </div>
                        }
                    </div>
                    }

                    @if (material.hasPreorder) {
                    <div class="shopping-cart">
                        <button class="preorder" (click)="addToCart(material)">ELŐRENDELÉS</button>
                    </div>
                    }
                </div>
                @if (material.bookExtractUrl) {
                <div class="extract-desktop" (click)="openPdf(material.bookExtractUrl)">
                    <a target="_blank">
                        <img src="./assets/images/materials/book_extract/beolvasas_icon.jpg" />
                    </a>
                    <span>Beleolvasó</span>
                </div>
                }
            </div>
        </div>

        <div class="sinapsis">
            <div class="content">
                <div class="author-title">
                    <h2 class="title">{{ material.title }}</h2>
                    @if (material.subtitle) {
                    <span>{{ material.subtitle }}</span>
                    }
                    <h2 class="author">{{ material.author }}</h2>
                </div>


                @if (material.routerLink !== 'morte_taska') {
                <div class="parameter-box">
                    <div class="param-box">
                        @if (material.originalPrice! > 0 || material.oldPrice) {
                        <div class="shopping-cart-containerr">
                            <div class="shopping-cartt">
                                @if (material.oldPrice !== material.originalPrice || material.hasPreorder) {
                                <span> Ár a könyvön: {{ material.oldPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}
                                </span>
                                }

                                @if (material.originalPrice! > 0 && material.webshopPriceActive) {
                                <div class="box">
                                    <h3>{{ material.discountLimitedUntil !== null ? 'Kötött ár:' : 'Kiadói ár:' }}</h3>
                                    <h3>{{ material.originalPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</h3>
                                    @if (material.discountLimitedUntil !== null) {
                                    <div class="info">
                                        <a href="https://jogkodex.hu/jsz/2024_13_torveny_6486371?ts=kozlony#pl9%C2%A7"
                                            target="_blank" [ngStyle]="{ color: 'black' }">
                                            <mat-icon>info</mat-icon>
                                        </a>
                                    </div>
                                    }
                                </div>
                                }

                                @else if (material.originalPrice! > 0 && material.discountPriceActive) {
                                <h3>Akciós ár: {{ material.originalPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}</h3>
                                }

                                @else if (material.hasPreorder) {
                                <h3 [ngStyle]="{ color: 'red', 'font-weight': 'bold' }">
                                    Előrendelői ár: {{ material.originalPrice | currency: 'Ft' : 'symbol' : '1.0-0' }}
                                </h3>
                                }
                            </div>
                            <div class="mobile-cart">
                                @if (material.isAvailable && material.routerLink !== 'morte_taska') {
                                <div class="shopping-cart-container">
                                    @if (!material.hasPreorder) {
                                    <div class="shopping-cart">
                                        @if (material.quantityOfSupply !== 0) {
                                        <button (click)="addToCart(material)">KOSÁRBA</button>
                                        } @else {
                                        <div class="inactive">
                                            <button class="inactive-button"
                                                [ngStyle]="{ opacity: '0.5', cursor: 'auto' }">
                                                Elfogyott
                                            </button>
                                        </div>
                                        }
                                    </div>
                                    }
                                </div>
                                }

                                @if (material.hasPreorder) {
                                <div class="shopping-cart">
                                    <button class="preorder" (click)="addToCart(material)">ELŐRENDELÉS</button>
                                </div>
                                }
                            </div>
                        </div>
                        }

                        @if (material.serieId !== null) {
                        <span [ngStyle]="{'margin-bottom':'8px','margin-top':'8px'}">{{ 'materials.serie' | translate }}
                            {{
                            serie.serieName }} {{ material.serieNumber
                            }}.</span>
                        }
                        @if (material.translator) {
                        <span>{{ 'materials.translator' | translate }} {{ material.translator }}</span>
                        }
                        @if (material.illustrator) {
                        <span>{{ 'materials.illustrator' | translate }} {{ material.illustrator }}</span>
                        }

                        <span>
                            {{ material.isAvailable ? ('materials.publishedBook' | translate) :
                            ('materials.expectedPublicationDate' | translate) }}
                            {{ material.available | dateUtil }}
                        </span>

                        @if (material.bond) { <span>{{ 'materials.bond' | translate }} {{ material.bond }}</span> }
                        @if (material.content) { <span>{{ 'materials.volume' | translate }} {{ material.content
                            }}</span> }
                        @if (material.dimension) { <span>{{ 'materials.size' | translate }} {{ material.dimension
                            }}</span> }
                        @if (material.isbn) { <span>{{ 'materials.isbn' | translate }} {{ material.isbn }}</span> }
                    </div>

                    @if (packageOfferOrFallback()) {
                    <div class="package-offer">
                        <h3>{{ 'specialOffer.title' | translate }}</h3>
                        <app-product-preview [product]="$any(packageOfferOrFallback())" (addToCart)="addToCart($event)" />
                    </div>
                    }
                </div>
                }

                @if (material.routerLink !== 'morte_taska' && material.txt) {
                <div class="text-data-container">
                    <div class="text-data">
                        <div [innerHTML]="material.txt"></div>
                    </div>
                    <pf-pressarticle />
                </div>
                }

                @if (material.routerLink === 'morte_taska') {
                <div class="parameter-taska-box">
                    <div class="param-taska-box">
                        <span>{{ 'materials.size' | translate }} {{ material.dimension }}</span>
                    </div>
                    @if (material.textData) {
                    <div class="text-data-taska-container">
                        <div class="text-taska-data">
                            <span>{{ material.textData }}</span>
                        </div>
                    </div>
                    }
                </div>
                }
            </div>
        </div>
    </div>
</div>
}
